import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside";
import Api from "../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import EditMidia from "./edit";
import NewMidia from "./new";
import ReactTooltip from "react-tooltip";
import { loadCidades } from "../../helpers/functions";

export default function AlbatrozMidia() {
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [cidades, setCidades] = useState([]);
  const [midia, setMidia] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [midiaEdit, setMidiaEdit] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const cidadesData = await loadCidades();
      await loadMidia();
      setCidades(cidadesData);
    }
    fetchData();
  }, []);

  function loadMidia() {
    return Api.get("/albatrozmidia/list")
      .then((response) => {
        setMidia(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function editItem(item) {
    setMidiaEdit(item);
    setOpenModalEdit(true);
  }

  function deleteItem(item) {
    swal({
      title: "Excluir mídia",
      text: `Remover ${item.tipo} #${item.id} ?`,
      icon: "warning",
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/albatrozmidia/delete/" + item.id)
          .then((response) => {
            swal(response.data.message, { icon: "success" });
            loadMidia();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, { icon: "error" });
            setLoading(false);
          });
      }
    });
  }

  function alteraAtivado(id, ativado) {
    setLoading(true);
    Api.post(`/albatrozmidia/ativado/${id}/${ativado}`)
      .then(() => {
        loadMidia();
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
        setLoading(false);
      });
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    return cidades.map((cidade) => {
      const rows = midia
        .filter((m) => m.nome_cidade === cidade.nome)
        .map((m) => {
          const preview =
            m.tipo === "foto" && m.arquivo ? (
              <img
                src={process.env.REACT_APP_FILES_URL + m.arquivo}
                alt=""
                style={{ maxHeight: 80 }}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: 10,
                }}
              >
                <i className="bx bx-play-circle" style={{ fontSize: 28 }}></i>
                <span
                  style={{
                    fontSize: 12,
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={m.video_url}
                >
                  {m.video_url}
                </span>
              </div>
            );

          const ativadoEl =
            m.ativado == "1" ? (
              <a
                href="#"
                className="ativado"
                onClick={(e) => {
                  e.preventDefault();
                  alteraAtivado(m.id, 0);
                }}
                data-tip="Clique para desativar"
              ></a>
            ) : (
              <a
                href="#"
                className="desativado"
                onClick={(e) => {
                  e.preventDefault();
                  alteraAtivado(m.id, 1);
                }}
                data-tip="Clique para ativar"
              ></a>
            );

          return (
            <div className="item" key={m.id}>
              <div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    editItem(m);
                  }}
                  data-tip="Editar"
                >
                  <i className="bx bx-edit"></i>
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    deleteItem(m);
                  }}
                  data-tip="Excluir"
                >
                  <i className="bx bx-trash"></i>
                </a>
                {ativadoEl}
                <span
                  style={{
                    marginLeft: 8,
                    fontSize: 11,
                    textTransform: "uppercase",
                    color: "#888",
                  }}
                >
                  {m.tipo}
                </span>
              </div>
              <div>{preview}</div>
            </div>
          );
        });

      return (
        <React.Fragment key={cidade.id}>
          <h2>{cidade.nome}</h2>
          <div className="grid fotos">
            <div className="content">{rows}</div>
          </div>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          <div className="top">
            <div>
              <span className="text">Mídia dos Destinos</span>
              <ul className="breadcrumbs">
                <li>Páginas de Destino</li>
                <li>Mídia dos Destinos</li>
              </ul>
            </div>
            <div>
              <div className="actions top">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModalNew(true);
                  }}
                >
                  <i className="bx bx-plus-circle"></i> Item
                </Link>
              </div>
            </div>
          </div>
          {midia && RenderContent()}
        </main>

        <Modal
          open={openModalNew}
          onClose={() => setOpenModalNew(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal" }}
        >
          <NewMidia
            loadMidia={loadMidia}
            setOpenModalNew={setOpenModalNew}
          />
        </Modal>

        <Modal
          open={openModalEdit}
          onClose={() => setOpenModalEdit(false)}
          classNames={{ overlay: "customOverlay", modal: "customModal" }}
        >
          {midiaEdit && (
            <EditMidia
              data={midiaEdit}
              loadMidia={loadMidia}
              setOpenModalEdit={setOpenModalEdit}
            />
          )}
        </Modal>
      </div>
    </>
  );
}
